export default function upcomingEvents() {
	const eventsBlocks = document.querySelectorAll('.upcoming-events');

	eventsBlocks.forEach(block => {
		initEventBlock(block);
	});

	if (window.location.hash) {
		const hash = window.location.hash.substring(1);
		if (hash.startsWith('events-filter-')) {
			const filter = hash.replace('events-filter-', '');
			eventsBlocks.forEach(block => {
				activateFilter(block, filter);
			});
		}
	}

	function initEventBlock(block) {
		const tabs = block.querySelectorAll('.basic-tabs__tab-button');
		const tabPanels = block.querySelectorAll('.basic-tabs__tab-content');
		const dynamicHeader = block.querySelector('.upcoming-events__dynamic-header');
		const viewAllPill = block.querySelector('.upcoming-events__view-all-pill');
		const tabsContainer = block.querySelector('.basic-tabs__tab-buttons-container');
		const tabsScroller = block.querySelector('.basic-tabs__tab-buttons');

		const enableDrag = window.innerWidth < 650;

		// Add click handlers to all tabs regardless of screen size
		tabs.forEach((tab) => {
			tab.addEventListener('click', function (e) {
				const filter = this.getAttribute('data-filter');
				activateFilter(block, filter);
			});
		});

		// Add drag functionality only on mobile
		if (tabsScroller && enableDrag) {
			tabsScroller.classList.add('--grabbable');

			let isDown = false;
			let startX = 0;
			let scrollLeft = 0;
			let dragThresholdMet = false;

			tabsScroller.addEventListener('mousedown', (e) => {
				isDown = true;
				tabsScroller.classList.add('--dragging');
				startX = e.pageX - tabsScroller.offsetLeft;
				scrollLeft = tabsScroller.scrollLeft;
				dragThresholdMet = false;
			});

			tabsScroller.addEventListener('mouseleave', () => {
				isDown = false;
				tabsScroller.classList.remove('--dragging');
			});

			tabsScroller.addEventListener('mouseup', () => {
				isDown = false;
				tabsScroller.classList.remove('--dragging');
				setTimeout(() => (dragThresholdMet = false), 0);
			});

			tabsScroller.addEventListener('mousemove', (e) => {
				if (!isDown) return;
				e.preventDefault();
				const x = e.pageX - tabsScroller.offsetLeft;
				const walk = (x - startX) * 1.5;
				if (Math.abs(walk) > 3) {
					dragThresholdMet = true;
					tabsScroller.scrollLeft = scrollLeft - walk;
				}
			});

			// Override click handlers on mobile to prevent clicks during drag
			tabs.forEach((tab) => {
				tab.addEventListener('click', function (e) {
					if (dragThresholdMet) {
						e.preventDefault();
						return;
					}
				});
			});
		}

		tabs.forEach((tab) => {
			tab.addEventListener('keydown', function (event) {
				if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
					event.preventDefault();
					const direction = event.key === 'ArrowLeft' ? -1 : 1;
					const tabArray = Array.from(tabs);
					const currentIndex = tabArray.indexOf(this);
					const nextIndex = (currentIndex + direction + tabArray.length) % tabArray.length;
					tabArray[nextIndex].focus();
				}
				if (event.key === ' ' || event.key === 'Enter') {
					event.preventDefault();
					this.click();
				}
			});
		});

		if (viewAllPill) {
			viewAllPill.addEventListener('click', function (event) {
				event.preventDefault();
				const target = document.querySelector(this.getAttribute('href'));
				if (target) {
					const offsetTop = target.getBoundingClientRect().top + window.scrollY;
					window.scrollTo({
						top: offsetTop,
						behavior: 'smooth',
					});
				}
			});
		}
	}

	function activateFilter(block, filter) {
		const tabs = block.querySelectorAll('[role="tab"], .basic-tabs__tab-button');
		tabs.forEach((tab) => {
			const isActive = tab.getAttribute('data-filter') === filter;
			tab.classList.toggle('--active', isActive);
			tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
		});

		const tabPanels = block.querySelectorAll('[role="tabpanel"], .basic-tabs__tab-content');
		tabPanels.forEach((panel) => {
			const isActive = panel.getAttribute('data-filter') === filter;
			panel.classList.toggle('--active', isActive);
			if (isActive) {
				panel.style.display = 'block';
				panel.removeAttribute('hidden');
			} else {
				panel.style.display = 'none';
				panel.setAttribute('hidden', '');
			}
		});

		updateDynamicHeader(block, filter);
		updateViewAllPill(block, filter);
		window.history.replaceState(null, null, '#events-filter-' + filter);
	}

	function updateDynamicHeader(block, filter) {
		const dynamicHeader = block.querySelector('.upcoming-events__dynamic-header p');
		if (!dynamicHeader) return;

		const activePanel = block.querySelector('[role="tabpanel"][data-filter="' + filter + '"]');
		if (!activePanel) return;

		const events = activePanel.querySelectorAll('.event-card').length;
		let label = '';

		switch (filter) {
			case 'past': {
				const firstPastEvent = activePanel.querySelector('.event-card__date');
				label = firstPastEvent ? firstPastEvent.textContent.replace(/\d+,\s/, '') : 'Past Events';
				break;
			}
			case 'this_month':
				label = new Date().toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
				break;
			case 'next_month': {
				const nextMonth = new Date();
				nextMonth.setMonth(nextMonth.getMonth() + 1);
				label = nextMonth.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
				break;
			}
			case 'this_year':
				label = new Date().getFullYear().toString();
				break;
			default:
				label = 'All Upcoming Events';
		}

		dynamicHeader.textContent = `${label} · ${events} events`;
	}

	function updateViewAllPill(block, filter) {
		const viewAllPill = block.querySelector('.upcoming-events__view-all-pill');
		if (!viewAllPill) return;

		viewAllPill.textContent =
			filter === 'past' ? 'All Past Events' : 'All Upcoming Events';
	}
}
